// extracted by mini-css-extract-plugin
module.exports = {"list":"Notifications_list__1bYvO","notification":"Notifications_notification__2mB7U","icon":"Notifications_icon__1PORS"};